import React, { useCallback } from 'react'
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material'
import {
  Business,
  CheckCircle,
  RateReview,
  Assignment
} from '@mui/icons-material'

const getTabIcon = (tabId) => {
  switch (tabId) {
    case 'firmSelection':
      return <Assignment />
    case 'campaignPreparation':
      return <RateReview />
    case 'reviewSend':
      return <CheckCircle />
    default:
      return <Business />
  }
}

const CampaignNavigationTabs = ({ tabs = [], activeTab, onTabChange }) => {
  const handleTabClick = useCallback((index, disabled) => {
    if (!disabled && onTabChange) {
      onTabChange(index)
    }
  }, [onTabChange])

  if (tabs.length === 0) return null

  return (
    <Box sx={{ py: 1.5 }}>
      <List sx={{ px: 1 }}>
        {tabs.map((tab, index) => {
          const isActive = activeTab === index
          const tabElement = (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => handleTabClick(index, tab.disabled)}
                disabled={tab.disabled}
                selected={isActive}
                sx={{
                  borderRadius: 2,
                  mx: 1,
                  mb: 0.5,
                  '&.Mui-selected': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    '& .MuiListItemIcon-root': {
                      color: 'primary.contrastText'
                    },
                    '& .MuiListItemText-primary': {
                      color: 'primary.contrastText'
                    },
                    '&:hover': {
                      backgroundColor: 'primary.dark'
                    }
                  },
                  '&:hover': {
                    backgroundColor: isActive ? 'primary.dark' : 'action.hover'
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  {tab.icon || getTabIcon(tab.id)}
                </ListItemIcon>
                <ListItemText
                  primary={tab.label}
                  primaryTypographyProps={{
                    fontSize: '0.875rem',
                    fontWeight: isActive ? 600 : 500
                  }}
                />
              </ListItemButton>
            </ListItem>
          )

          if (tab.disabled && tab.tooltip) {
            return (
              <Tooltip key={index} title={tab.tooltip} arrow placement="right">
                <div>{tabElement}</div>
              </Tooltip>
            )
          }

          return tabElement
        })}
      </List>
    </Box>
  )
}

export default CampaignNavigationTabs
